import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_APP_DEVELOPMENT } from "@/lib/service-content/faqs/app-development";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/shopify-app-development";

export const Route = createFileRoute("/shopify-app-development")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify App Development: Public, Custom & Embedded Apps · Shugert",
    description: "Shopify app development with explicit product boundaries, supported extensions, security, billing, observability and launch operations. From $6,000.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-app-development-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }, { name: "Shopify App Development", path: PATH }]),
      faqJsonLd(FAQS_APP_DEVELOPMENT.en),
      serviceJsonLd({
        name: "Shopify App Development",
        description: "Public, custom and embedded Shopify applications with supported platform surfaces, security, billing, observability and a defined operating model.",
        path: PATH,
        serviceType: "Shopify App Development",
        minPrice: 6000,
        unit: "PROJECT",
        deliverables: ["Product boundary and permissions", "Shopify platform architecture", "Operational and security design", "Staged app implementation", "Launch or submission package"],
        locale: "en",
      }),
    ],
  }),
});
